import React from 'react'
import type { LinkProps } from './index'

export type NativeLinkProps = Omit<LinkProps, 'useNative'>

export const NativeLink = ({ ...props }: NativeLinkProps) => {
  //if disabled uses div, else uses a
  if (props.disabled) {
    return <div className={props.className}>{props.children}</div>
  }

  return (
    <a
      href={props.href ?? '#'}
      {...props}
      onClick={(e) => {
        if (!props.href || props.href === '#') e.preventDefault()
        return props.onClick?.(e)
      }}
    >
      {props.children}
    </a>
  )
}
